import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useState,
} from 'react';
import { MdClose } from 'react-icons/md';
import { MenuItem } from 'react-pro-sidebar';

export const DropdownGemeenteBench = forwardRef((props, selGemBenchRef) => {
  const {
    gemeenteLijst,
    selectedGemeente,
    benchmarkLijst,
    selectedBenchmarks,
    interfaceColor,
    d_ruimte,
  } = props;

  const [selGem, setSelGem] = useState(selectedGemeente);
  const [selBench, setSelBench] = useState(selectedBenchmarks);
  const [benchList, setBenchList] = useState(benchmarkLijst);

  useImperativeHandle(selGemBenchRef, () => ({
    getSelGem: () => {
      return selGem;
    },
    getSelBench: () => {
      return selBench;
    },
  }));

  const onChangeBenchmarkHandler = (event: any) => {
    event.preventDefault();
    let newObj = JSON.parse(event.target.value);
    newObj.label = newObj.ruimte;
    setSelBench([newObj]);
  };

  useEffect(() => {
    setSelGem(selectedGemeente);
  }, [selectedGemeente]);

  useEffect(() => {
    setSelBench(selectedBenchmarks);
  }, [selectedBenchmarks]);

  const onChangeGemeenteHandler = (event: any) => {
    event.preventDefault();
    let newSelGem = JSON.parse(event.target.value);
    newSelGem.label = newSelGem.ruimte;

    const vlgewest = d_ruimte.filter((d: any) => {
      return parseInt(d?.isVlaamsGewest) === 1;
    });

    const centrumSteden = d_ruimte.filter((d: any) => {
      return parseInt(d?.is13CentrumSteden) === 1;
    });

    const facil = d_ruimte.filter((d: any) => {
      return parseInt(d?.isFaciliteitenGemeente) === 1;
    });

    const nietFacil = d_ruimte.filter((d: any) => {
      return parseInt(d?.isNietFaciliteitenGemeente) === 1;
    });

    const vlRand = d_ruimte.filter((d: any) => {
      return parseInt(d?.isVlaamseRand) === 1;
    });

    const belfius = d_ruimte.filter((d: any) => {
      return parseInt(d.id) === parseInt(newSelGem?.idRuimteBelfiusCluster);
    });

    const buurGem = d_ruimte.filter((d: any) => {
      return parseInt(d.id) === parseInt(newSelGem?.idRuimteBuurgemeenten);
    });

    const gemGrootte = d_ruimte.filter((d: any) => {
      return parseInt(d.id) === parseInt(newSelGem?.idRuimteGemeenteGrootte);
    });

    const prov = d_ruimte.filter((d: any) => {
      return parseInt(d.id) === parseInt(newSelGem?.idRuimteProvincie);
    });

    const regio = d_ruimte.filter((d: any) => {
      return parseInt(d.id) === parseInt(newSelGem?.idRuimteRegio);
    });

    const allBench = vlgewest
      .concat(
        prov,
        regio,
        belfius,
        gemGrootte,
        buurGem,
        centrumSteden,
        vlRand,
        facil,
        nietFacil,
      )
      .map((d: any) => {
        d.bench = 1;
        return d;
      });

    const sortedCities = d_ruimte
      .filter((d: any) => {
        return parseInt(d.isVlaamseGemeente) === 1 && d.isFusie === 0;
      })

      .sort((a: any, b: any) => {
        let fa = a.ruimte.toLowerCase(),
          fb = b.ruimte.toLowerCase();

        if (fa < fb) {
          return -1;
        }
        if (fa > fb) {
          return 1;
        }
        return 0;
      })
      .map((d: any) => {
        d.bench = 0;
        return d;
      });

    const citiesBench = allBench.concat(sortedCities).filter((d: any) => {
      return parseInt(d.id) !== parseInt(newSelGem?.id);
    });

    const uniqueIDs = [...new Set(citiesBench.map((d: any) => d.idRuimte))];
    const newSelBench = selBench.filter((d: any) => {
      return uniqueIDs.includes(d.idRuimte);
    });

    setSelGem(newSelGem);
    setBenchList(citiesBench);
    setSelBench(newSelBench);
  };

  return (
    <>
      <MenuItem>
        Kies een gemeente
        <div className="vl-form-col--12-12" style={{ padding: '0.6rem' }}>
          <select
            name="gemeente"
            className="vl-select vl-select--block"
            tabIndex={0}
            data-vl-select=""
            data-vl-select-search-empty-text="Geen resultaten gevonden"
            onChange={onChangeGemeenteHandler}
          >
            {gemeenteLijst.map((d: any, i: number) => (
              <option
                key={d.id}
                value={JSON.stringify(d)}
                selected={d.ruimte === selGem.label}
              >
                {d.ruimte}
              </option>
            ))}
          </select>
        </div>
      </MenuItem>
      <>
        <MenuItem>
          Kies een benchmark
          <div className="vl-form-col--12-12" style={{ padding: '0.6rem' }}>
            <select
              name="gemeente"
              className="vl-select vl-select--block"
              tabIndex={0}
              data-vl-select=""
              data-vl-select-search-empty-text="Geen resultaten gevonden"
              onChange={onChangeBenchmarkHandler}
            >
              <optgroup label="Gebiedsomschrijvingen">
                {benchList !== undefined &&
                  benchList
                    .filter((d: any) => d.bench === 1)
                    .map((d: any, i: number) => (
                      <option
                        key={d.id}
                        value={JSON.stringify(d)}
                        selected={
                          selBench.length > 0 &&
                          d.ruimte === selBench[selBench.length - 1].label
                        }
                      >
                        {d.ruimte}
                      </option>
                    ))}
              </optgroup>
              <optgroup label="Gemeenten">
                {benchList !== undefined &&
                  benchList
                    .filter((d: any) => d.bench === 0)
                    .map((d: any, i: number) => (
                      <option
                        key={d.id}
                        value={JSON.stringify(d)}
                        selected={
                          selBench.length > 0 &&
                          d.ruimte === selBench[selBench.length - 1].label
                        }
                      >
                        {d.ruimte}
                      </option>
                    ))}
              </optgroup>
            </select>
          </div>
        </MenuItem>
      </>
    </>
  );
});

export default React.memo(DropdownGemeenteBench);
